export default __webpack_public_path__ + "static/media/UK.13320778.png";